import {
  AlimtalkMessageDoc,
  PackingInfoSnapshot,
  packingInfoSnapshotPath,
  BusinessInfoDoc,
  Channel,
  ChannelCategoryConfDoc,
  ChannelDoc,
  ChannelMessage,
  ChannelMessageDoc,
  CJFreshwayProduct,
  CJFreshwayProductListDoc,
  CommerceConf,
  CompetitorProductMapping,
  CompetitorProductMappingDoc,
  CustomPromotionSection,
  CustomPromotionSectionDoc,
  DabomFoodProduct,
  DabomFoodProductListDoc,
  DailyInventoryChanges,
  DailyInventoryChangesDoc,
  DailyIssue,
  DailyIssueDoc,
  FCMRequestDoc,
  DailyOrderStatsDoc,
  DailyProductStatsDoc,
  DeliveryCourier,
  DeliveryCourierDoc,
  DeliveryPerformanceDoc,
  DeliveryRouteHistory,
  DeliveryRouteHistoryDoc,
  CommerceDeviceDoc,
  DeliverySpot,
  DeliverySpotDoc,
  EmployeeRef,
  DeliveryTask,
  DeliveryTaskDoc,
  DeviceDoc,
  FoodpangProductDoc,
  FoodpangProductListDoc,
  FriendtalkMessageDoc,
  GarakMarketProductListDoc,
  GarakMarketProductPriceTrend,
  GarakMarketProductPriceTrendDoc,
  GuProductPriceTrendDoc,
  HyosungCMSMember,
  HyosungCMSMemberDoc,
  ImageFile,
  ImageFileOriginalDoc,
  ImageFileThumbnailDoc,
  InventoryBinLocationDoc,
  InventoryIssue,
  InventoryIssueDoc,
  Invoice,
  InvoiceDetailDoc,
  InvoiceDoc,
  InvoiceMessageMapDoc,
  IssueAmountStructure,
  IssueCase,
  IssueCaseDoc,
  IssueCaseMessageLink,
  IssueCaseMessageLinkDoc,
  IssueCaseStatusCode,
  IssueImage,
  IssueLiability,
  IssueLiabilityDoc,
  IssueProduct,
  IssueTask,
  IssueTaskDoc,
  IssueTaskStatus,
  KakaoBrandMessageDoc,
  LogDoc,
  LogOrder,
  MemoDoc,
  MessageCategoryConfig,
  MobileMessageDoc,
  MonthlyOrderStatsForStoreDoc,
  Notification,
  NotificationDoc,
  OrderDoc,
  OrderProductAlertConf,
  OrderProductAlertConfDoc,
  OrderStatusCode,
  PartnersDeviceDoc,
  PartnersUserDoc,
  PartnersVehicle,
  PartnersVehicleDoc,
  PaymentItem,
  PaymentItemDoc,
  PickupTask,
  PickupTaskDoc,
  Product,
  ProductBatchUpdateHistory,
  ProductBatchUpdateHistoryDoc,
  ProductCompetitorTrendKeywordMap,
  ProductDoc,
  ProductGroupForCategoryDoc,
  ProductInboundTransactionDoc,
  ProductInventory,
  ProductInventoryDoc,
  ProductInventoryHistoryDoc,
  ProductInventoryUnit,
  ProductOutboundTransactionDoc,
  ProductSnapshotDoc,
  ProductSupplier,
  ProductSupplierDoc,
  ProductSupplierInventoryReceipt,
  ProductSupplierInventoryReceiptDoc,
  ProductSupplierPurchaseOrderDoc,
  ProductWeeklyPriceDoc,
  PromotionSection,
  PromotionSectionDoc,
  PurchaseOrderMessageSendRequest,
  PurchaseOrderMessageSendRequestCollection,
  PurchaseOrderSectionConfig,
  PurchaseOrderSectionConfigDoc,
  SalesConfig,
  SalesConfigDoc,
  SehyeonFnBProduct,
  SehyeonFnBProductListDoc,
  SettlementResult,
  SettlementResultDoc,
  StoreDoc,
  StoreIssue,
  StoreIssueDoc,
  CommerceNotice,
  CommerceNoticeDoc,
  StoreSearchIndex,
  StoreSalesInfo,
  StoreSalesInfoDoc,
  UserDoc,
} from '@gooduncles/gu-app-schema';
import { DeepPartial } from '@reduxjs/toolkit';
import { notification } from 'antd';
import { format } from 'date-fns';
import { FieldValue, Timestamp, arrayRemove, arrayUnion, deleteField } from 'firebase/firestore';
import { StorageReference, UploadMetadata } from 'firebase/storage';
import { uniqBy } from 'lodash-es';
import { map } from 'rxjs';
import { imageBaseUrl } from 'src/constants';

import { formatDate, getDateWithoutTime } from 'src/utils/date-util';
import { ConsoleDevice, ConsoleDeviceDoc, consoleDevicePath } from 'src/utils/firebase/console-device-types';
import { AuditOptions, FirebaseManager, QueryOptions, WHERE } from 'src/utils/firebase/firebase-manager';

const firebaseManager = FirebaseManager.getInstance();
export const batchStart = () => firebaseManager.batchStart();
export const batchEnd = () => firebaseManager.batchEnd();
export const uploadFile = (path: string, file: File, metadata?: UploadMetadata) =>
  firebaseManager.uploadFile(path, file, metadata);
export const getDownloadURL = (ref: StorageReference) => firebaseManager.getDownloadURL(ref);
export const storageUploadFile = (bucket: string, path: string, file: File, metadata?: UploadMetadata) =>
  firebaseManager.storageUploadFile(bucket, path, file, metadata);
export const storageDeleteFile = (bucket: string, path: string) => firebaseManager.storageDeleteFile(bucket, path);
export const getCollectionCount = (collectionPath: string, wheres: WHERE[], options: QueryOptions) =>
  firebaseManager.getCollectionCount(collectionPath, wheres, options);
export const fbCreateUserWithEmailAndPassword = (email: string, password: string) =>
  firebaseManager.createUserWithEmailAndPassword(email, password);
export const fbSignInWithEmailAndPassword = (email: string, password: string) =>
  firebaseManager.signIn(email, password);
export const fbSignOut = () => firebaseManager.signOut();
export const fbObserveAuthState = () => firebaseManager.observeAuthState();
export const fbGetCurrentUser = () => firebaseManager.getCurrentUser();

const productPath = 'product';
const devicePath = 'device';
const notificationPath = 'notification';

// alimtalk
const alimtalkMessagePath = 'alimtalkMessage';
// friendtalk
const friendtalkMessagePath = 'friendtalkMessage';

export function getCollectionWithWhere<T>(collection: string, where: WHERE[] = [], options?: QueryOptions) {
  return firebaseManager.getDocsArrayWithWhere<T>(collection, where, options);
}

export const getLastProductId = async () => {
  const lastProduct = await firebaseManager.getDocsArrayWithWhere<ProductDoc>(productPath, [], {
    sortKey: '_id',
    orderBy: 'desc',
    limit: 1,
  });
  return lastProduct?.[0]?._id;
};
export const getNewProductId = async () => {
  const lastProductId = await getLastProductId();
  if (lastProductId) {
    const productIdRegex = /([a-zA-Z]+)([0-9]+)/;
    const lastProductIdMatch = lastProductId.match(productIdRegex);
    if (lastProductIdMatch) {
      return lastProductIdMatch[1] + `${parseInt(lastProductIdMatch[2]) + 1}`.padStart(5, '0');
    }
  }
  return `${lastProductId}-error`;
};
export const getProduct = async (productId: string) =>
  firebaseManager.getDoc<ProductDoc>(`${productPath}/${productId}`);
export const getProductsByIds = async (ids: string[]): Promise<(ProductDoc | null)[]> =>
  Promise.all(ids.map(async (id) => (await getProduct(id)) ?? null));
/** 상품 생성은 오직 이 API만 사용한다. */
export const createProduct = async (data: Product, options?: { bBatch?: boolean; audit?: AuditOptions }) =>
  firebaseManager.createDoc(productPath, data.productId, data, options);
export const updateProduct = async (
  productId: string,
  product: Partial<ProductDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(productPath, productId, product, {
    bBatch,
    audit,
  });
};
/**
 * product-image/P12559
 * @param path
 */
export const deleteProductImage = async (path: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  const [dir, id] = path.split('/');
  if (dir !== 'product-image' || !id) {
    throw new Error('Invalid path');
  }

  const product = await getProduct(id);
  if (!product) {
    throw new Error('Invalid product');
  }

  const { imageUrl, thumbnail } = product;
  if (!imageUrl || !thumbnail) {
    throw new Error(`Invalid image url\n${imageUrl}\n${thumbnail}`);
  }
  const originRegex = /product-image\/\w+(\.png)?/;
  const thumbRegex = /product-thumb\/\w+(\.jpg)?/;
  const originPath = decodeURIComponent(imageUrl)?.match(originRegex)?.[0];
  const thumbPath = decodeURIComponent(thumbnail)?.match(thumbRegex)?.[0];
  if (!originPath || !thumbPath) {
    throw new Error(`Invalid path\n${originPath}\n${thumbPath}`);
  }
  const data: Partial<ProductDoc> = {
    imageUrl: null,
    thumbnail: null,
  };
  // 1. 링크 해제. (primary write — audit applies here)
  await firebaseManager.updateDoc(productPath, id, data, { audit });

  // 2. 서버의 파일 삭제.(thumbnail, original)
  await firebaseManager.deleteFile(originPath);
  await firebaseManager.deleteFile(thumbPath);
  return;
};
/**
 * 상품 구독. soft-delete(`_timeDelete`)된 상품은 제외한다.
 * Firestore 는 필드가 없는 문서를 `== null` 로 못 찾으므로 클라이언트에서 거른다.
 */
export const observeProducts = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager
    .observeCollection<ProductDoc>(productPath, where, options)
    .pipe(map((products) => products.filter((product) => !product._timeDelete)));
export const getProductsWithWhere = (where: WHERE[]) =>
  firebaseManager.getDocsArrayWithWhere<ProductDoc>(productPath, where);

export const getDevices = () => {
  return firebaseManager.getDocsArrayWithWhere<DeviceDoc>(devicePath, []);
};

const commerceDevicePath = 'commerceDevice';
/**
 * v2(Commerce 앱) 사용자가 로그인한 기기 목록을 조회한다.
 * 문서 ID는 deviceUniqueId이며 userId로 필터링한다.
 */
export const getCommerceDevicesByUserId = (userId: string) =>
  firebaseManager.getDocsArrayWithWhere<CommerceDeviceDoc>(commerceDevicePath, [['userId', '==', userId]]);

/**
 * return 되는 uploadTask를 이용해서 다양한 액션이 가능하다.
 *
 * - 일시중지, 재시작: uploadTask.pause(); uploadTask.resume();
 * - 취소: uploadTask.cancel();
 *
 * 업로드 진행상황 모니터링
 * {@link https://firebase.google.com/docs/storage/web/upload-files#monitor_upload_progress monitor_upload_progress}
 * - uploadTask.on('state_changed', (snapshot) => {...});
 *
 * @returns uploadTask
 */
export const uploadFileWithManaging = async (path: string, file: File, metadata?: UploadMetadata) => {
  return firebaseManager.uploadTask(path, file, {
    ...metadata,
    contentType: 'image/jpeg',
  });
};

const userPath = 'user';
export const updateUser = async (uid: string, user: Partial<UserDoc>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(userPath, uid, user, { audit });
};

export const getUsersWithWhere = async (where: WHERE[] = []) =>
  firebaseManager.getDocsArrayWithWhere<UserDoc>(userPath, where);

export const getUser = async (userId: string) => firebaseManager.getDoc<UserDoc>(`${userPath}/${userId}`);

export const getUsers = async (where: WHERE[] = []) => firebaseManager.getDocsArrayWithWhere<UserDoc>(userPath, where);

export const observeUser = (userId: string) => firebaseManager.observeDoc<UserDoc>(`${userPath}/${userId}`);

export const observeUsers = (where: WHERE[] = []) => firebaseManager.observeCollection<UserDoc>(userPath, where);

export interface StoreUserDevices {
  user: UserDoc;
  devices: CommerceDeviceDoc[];
}

/**
 * 매장에 속한 사용자별 Commerce 앱 기기 목록을 조회한다.
 * commerceDevice에는 storeId가 없어 user(storeId) → commerceDevice(userId) 2단계로 조회한다.
 */
export const getStoreUserDevices = async (storeId: string): Promise<StoreUserDevices[]> => {
  const users = await getUsersWithWhere([['storeId', '==', storeId]]);
  return Promise.all(
    users.map(async (user) => ({
      user,
      devices: await getCommerceDevicesByUserId(user._id),
    })),
  );
};

// notification
export const createNotificationWithBatch = async (
  requiredFields: {
    publishDate: string;
    groupId: string;
    userId: string;
    title: string;
    body: string;
    uri: string;
  },
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  const { groupId, title, uri, body, userId, publishDate } = requiredFields;
  const notification: Notification = {
    groupId,
    userId,
    deviceId: null,
    title,
    body,
    action: {
      type: 'notion',
      uri,
    },
    isDeleted: false,
    unread: true,
    kind: 'promotion',
    publishDate,
    data: null,
    publisher: {
      id: 'admin',
      nickname: '관리자',
      avatarImage: `${imageBaseUrl}%2Fcommon%2Fic-gooduncles-orange.svg?alt=media`,
    },
  };
  return firebaseManager.createDoc(notificationPath, undefined, notification, { bBatch: true, audit });
};

export const observeNotification = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<NotificationDoc>(notificationPath, where, options);

/**
 * 지정한 가게의 3개월 동안의 주문 상품 목록을 가져온다.
 * @returns
 */
export const getOrderProductIdsForStoreWithRange = async (path: string, monthRange = 3) => {
  const storeId = path.split('/')[1];
  const now = new Date();
  const endDate = format(new Date(now.setMonth(now.getMonth() - monthRange)), "yyyy-MM-dd'T'HH:mm:ss+0900");
  try {
    const orders = await firebaseManager.getDocsArrayWithWhere<OrderDoc>(
      orderPath,
      [
        ['storeId', '==', storeId],
        ['orderDate', '>=', endDate],
        ['orderStatus', '==', OrderStatusCode.DELIVERED],
      ],
      {
        sortKey: 'orderDate',
        orderBy: 'desc',
      },
    );
    const orderedProducts = orders.flatMap((order) => order.products);
    const uniqueProducts = uniqBy(orderedProducts, 'productId');
    return uniqueProducts;
  } catch (error: any) {
    console.error(error);
    notification.error({
      message: '이전 주문내역을 가져오는데 실패했습니다.',
      description: error.message,
    });
  }
  return [];
};
/**
 * 매장의 최근 n개월 이내 '배송완료'주문 목록을 가져옵니다.
 * @param storeId
 * @param monthRange 입력 개월 이내의 주문을 가져옵니다.(기본 2개월)
 * @returns
 */
export const getOrderForStore = (storeId: string, monthRange: number) => {
  const now = new Date();
  const endDate = format(new Date(now.setMonth(now.getMonth() - monthRange)), "yyyy-MM-dd'T'HH:mm:ss+0900");
  return firebaseManager.getDocsArrayWithWhere<OrderDoc>(
    orderPath,
    [
      ['storeId', '==', storeId],
      ['orderDate', '>=', endDate],
      ['orderStatus', '==', OrderStatusCode.DELIVERED],
    ],
    {
      sortKey: 'orderDate',
      orderBy: 'desc',
    },
  );
};

export const observeOrder = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<OrderDoc>(orderPath, where, options);
export const getOrder = (orderId: string) => firebaseManager.getDoc<OrderDoc>(`${orderPath}/${orderId}`);

// Store
const storePath = 'store';
export const observeStore = (where: WHERE[] = []) => firebaseManager.observeCollection<StoreDoc>(storePath, where);
export const getStore = (storeId: string) => firebaseManager.getDoc<StoreDoc>(`${storePath}/${storeId}`);
export const getStores = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<StoreDoc>(storePath, where, options);
export const updateStore = (
  storeId: string,
  store: Partial<StoreDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(storePath, storeId, store, {
    bBatch,
    audit,
  });
};
export const getStoreWithWhere = (where: WHERE[] = []) =>
  firebaseManager.getDocsArrayWithWhere<StoreDoc>(storePath, where);

// StoreSearchIndex
const storeSearchIndexPath = 'store_search_index';
export const getStoreSearchIndexes = () =>
  firebaseManager
    .getDocsWithWhere<StoreSearchIndex>(storeSearchIndexPath, [])
    .then((docs) =>
      Object.entries(docs).map(([docId, data]) => ({ ...data, _id: docId }) as StoreSearchIndex & { _id: string }),
    );

// StoreIssue
const storeIssuePath = 'storeIssue';
export const getStoreIssue = (id: string) => firebaseManager.getDoc<StoreIssueDoc>(`${storeIssuePath}/${id}`);
export const getStoreIssues = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<StoreIssueDoc>(storeIssuePath, where, options);
export const observeStoreIssue = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<StoreIssueDoc>(storeIssuePath, where, options);

export const createStoreIssue = (options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  const storeIssue: StoreIssue = {
    date: formatDate(getDateWithoutTime(1), "yyyy-MM-dd'T'HH:mm:ss+0900"),
    category: null,
    storeCode: null,
    storeName: null,
    supplier: null,
    productId: null,
    productName: null,
    volume: 1,
    supplyPrice: null,
    tax: null,
    memo: null,
    message: null,
    status: null,
    completedAt: null,
    isDeleted: false,

    deliveryPartnerId: null,
    deliveryPartnerName: null,
    deliverySpotId: null,
    deliveryTaskFinishedAt: null,

    pickupPartnerId: null,
    pickupPartnerName: null,
    pickupTaskFinishedAt: null,

    settledAt: null,
    invoiceId: null,
  };
  return firebaseManager.createDoc(storeIssuePath, undefined, storeIssue, { audit });
};

export const updateStoreIssue = (
  id: string,
  data: Partial<StoreIssue>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(storeIssuePath, id, data, {
    bBatch,
    audit,
  });
};

// general
export function updateDocWithCollection<T>(
  colleciton: string,
  id: string,
  data: Partial<T>,
  options?: { audit?: AuditOptions },
) {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(colleciton, id, data, { audit });
}

// order
const orderPath = 'order';
export const getOrders = async (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<OrderDoc>(orderPath, where, options);
export const updateOrder = async (
  orderId: string,
  order: Partial<OrderDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(orderPath, orderId, order, {
    bBatch,
    audit,
  });
};
export const getOrdersForUserId = async (userId: string) =>
  firebaseManager.getDocsArrayWithWhere<OrderDoc>(orderPath, [['userId', '==', userId]]);
export const getDeliveredOrdersWithRange = async (startValue: string, endValue: string) =>
  firebaseManager.getDocsArrayWithWhere<OrderDoc>(orderPath, [['orderStatus', 'in', [OrderStatusCode.DELIVERED]]], {
    sortKey: 'orderDate',
    orderBy: 'desc',
    startValue,
    endValue,
  });
export const observeOrders = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<OrderDoc>(orderPath, where, options);

// monthlyOrderStatsForStore
const monthlyOrderStatsForStorePath = 'monthlyOrderStatsForStore';
export const getMonthlyOrderStatsForStore = async (where: WHERE[] = []) =>
  firebaseManager.getDocsArrayWithWhere<MonthlyOrderStatsForStoreDoc>(monthlyOrderStatsForStorePath, where);

// dailyOrderStats
const dailyOrderStatsPath = 'dailyOrderStats';
export const getDailyOrderStats = async (where: WHERE[] = []) =>
  firebaseManager.getDocsArrayWithWhere<DailyOrderStatsDoc>(dailyOrderStatsPath, where);

// dailyProductStats
const dailyProductStatsPath = 'dailyProductStats';
export const getDailyProductStats = async (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<DailyProductStatsDoc>(dailyProductStatsPath, where, options);

// config
const configPath = 'config';
export const updateCommerceConf = async (data: Partial<CommerceConf>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(configPath, 'commerce', data, { audit });
};
export const getCommerceConf = () => firebaseManager.getDoc<CommerceConf>(`${configPath}/commerce`);
export const observeCommerceConf = () => firebaseManager.observeDoc<CommerceConf>(`${configPath}/commerce`);
export const observeInvoiceMessageMapConf = () =>
  firebaseManager.observeDoc<InvoiceMessageMapDoc>(`${configPath}/invoiceMessageMap`);
export const updateInvoiceMessageMapConf = (
  data: Partial<InvoiceMessageMapDoc>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(configPath, 'invoiceMessageMap', data, { audit });
};
// salesConfig
export const getSalesConfig = () => firebaseManager.getDoc<SalesConfigDoc>(`${configPath}/salesConfig`);
export const observeSalesConfig = () => firebaseManager.observeDoc<SalesConfigDoc>(`${configPath}/salesConfig`);
export const setSalesConfig = (data: SalesConfig, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(configPath, 'salesConfig', data, { audit });
};
export const updateSalesConfig = (data: Partial<SalesConfig>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(configPath, 'salesConfig', data, { audit });
};
export const observeGarakMarketProductList = () =>
  firebaseManager.observeDoc<GarakMarketProductListDoc>('config/garakMarketProductList');
export const observeDabomFoodProductList = () =>
  firebaseManager.observeDoc<DabomFoodProductListDoc>('config/dabomFoodProductList');
export const observeCJFreshwayProductList = () =>
  firebaseManager.observeDoc<CJFreshwayProductListDoc>('config/CJFreshwayProductList');
export const observeSehyeonFnBProductList = () =>
  firebaseManager.observeDoc<SehyeonFnBProductListDoc>('config/sehyeonFnBProductList');
export const observeFoodpangProductList = () =>
  firebaseManager.observeDoc<FoodpangProductListDoc>('config/foodpangProductList');
export const observeInventoryBinLocation = () =>
  firebaseManager.observeDoc<InventoryBinLocationDoc>('config/inventoryBinLocation');
export const updateInventoryBinLocationItem = (
  inventoryId: string,
  value: string | null,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    configPath,
    'inventoryBinLocation',
    {
      [`inventoryBinLocation.${inventoryId}`]: value ? value : deleteField(),
    },
    { audit },
  );
};

export const observeProductCompetitorTrendKeywordMap = () =>
  firebaseManager.observeDoc<ProductCompetitorTrendKeywordMap>('config/productCompetitorTrendKeywordMap');
export const updateProductCompetitorTrendKeywordMap = (
  productId: string,
  data: string | FieldValue,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    configPath,
    'productCompetitorTrendKeywordMap',
    {
      [`productCompetitorTrendKeywordMap.${productId}`]: data,
    },
    { audit },
  );
};

// channelCategory
export const observeChannelCategoryConf = () =>
  firebaseManager.observeDoc<ChannelCategoryConfDoc>(`${configPath}/channelCategory`);
export const setChannelCategoryConf = (data: { categories: Record<string, MessageCategoryConfig> }) =>
  firebaseManager.setDoc(configPath, 'channelCategory', data);
export const updateChannelCategory = (categoryKey: string, value: MessageCategoryConfig) =>
  firebaseManager.updateDoc(configPath, 'channelCategory', {
    [`categories.${categoryKey}`]: value,
  });
export const deleteChannelCategory = (categoryKey: string) =>
  firebaseManager.updateDoc(configPath, 'channelCategory', {
    [`categories.${categoryKey}`]: deleteField(),
  });

// productGroupForCategory
const productGroupForCategoryPath = 'productGroupForCategory';
export const observeProductGroupForCategoryDoc = (category: string) =>
  firebaseManager.observeDoc<ProductGroupForCategoryDoc>(`${productGroupForCategoryPath}/${category}`);

export const observeProductGroupForCategory = (where: WHERE[], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductGroupForCategoryDoc>(productGroupForCategoryPath, where, options);

export const mergeProductGroupForCategory = (
  category: string,
  data: DeepPartial<ProductGroupForCategoryDoc>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(productGroupForCategoryPath, category, data, {
    bMerge: true,
    audit,
  });
};

// alimtalk
export async function getAlimtalkMessage<T>(id: string) {
  return firebaseManager.getDoc<AlimtalkMessageDoc<T>>(`${alimtalkMessagePath}/${id}`);
}
export const observeAlimtalkMessage = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<AlimtalkMessageDoc<any>>(alimtalkMessagePath, where, options);

// friendtalk
export async function getFriendtalkMessage(id: string) {
  return firebaseManager.getDoc<FriendtalkMessageDoc>(`${friendtalkMessagePath}/${id}`);
}
export const observeFriendtalkMessage = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<FriendtalkMessageDoc>(friendtalkMessagePath, where, options);

// mobileMessage
const mobileMessagePath = 'mobileMessage';
export const observeMobileMessage = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<MobileMessageDoc>(mobileMessagePath, where, options);
export const getMobileMessage = (id: string) => firebaseManager.getDoc<MobileMessageDoc>(`${mobileMessagePath}/${id}`);

// kakaoBrandMessage
const kakaoBrandMessagePath = 'kakaoBrandMessage';
export const observeKakaoBrandMessage = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<KakaoBrandMessageDoc>(kakaoBrandMessagePath, where, options);

// deliverySpot
const deliverySpotPath = 'deliverySpot';
export const getDeliverySpot = (id: string) => firebaseManager.getDoc<DeliverySpotDoc>(`${deliverySpotPath}/${id}`);
export const observeDeliverySpot = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<DeliverySpotDoc>(deliverySpotPath, where, options);
export const getDeliverySpots = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<DeliverySpotDoc>(deliverySpotPath, where, options);
export const updateDeliverySpot = (
  id: string,
  data: Partial<DeliverySpotDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch, audit } = options ?? {};
  return firebaseManager.updateDoc(deliverySpotPath, id, data, { bBatch, audit });
};
/**
 * 콘솔 저장 표시 필드. 좌표(관심 필드)를 쓸 때 함께 쓴다.
 * docVersion 트리거는 파트너 허용 필드 밖 키가 바뀌면 직원 수정으로 판별하므로, 겸직 계정의 콘솔 수정이 파트너 수정으로 찍히지 않는다.
 * 콘솔에서 만들거나 고친 배송지는 사람이 본 것이므로 확인(reviewedAt·reviewedBy)도 같은 값으로 찍는다.
 */
export const getDeliverySpotEditStamp = async (): Promise<
  Pick<DeliverySpot, 'updatedAt' | 'updatedBy' | 'reviewedAt' | 'reviewedBy'>
> => {
  const authUser = fbGetCurrentUser();
  if (!authUser) throw new Error('로그인 정보가 없습니다.');
  const user = await getUser(authUser.uid);
  const updatedBy: EmployeeRef = {
    uid: authUser.uid,
    name: user?.userName ?? null,
    email: authUser.email ?? user?.email ?? null,
  };
  const updatedAt = formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900");
  return { updatedAt, updatedBy, reviewedAt: updatedAt, reviewedBy: updatedBy };
};
export const createDeliverySpot = (data: DeliverySpot, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch, audit } = options ?? {};
  return firebaseManager.createDoc(deliverySpotPath, undefined, data, { bBatch, audit });
};
export const deleteDeliverySpot = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    deliverySpotPath,
    id,
    { isDeleted: true, _timeDelete: Timestamp.now() },
    {
      bBatch,
      audit,
    },
  );
};

// deliveryCourier
const deliveryCourierPath = 'deliveryCourier';
export const getDeliveryCouriers = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<DeliveryCourierDoc>(deliveryCourierPath, where, options);
export const observeDeliveryCourier = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<DeliveryCourierDoc>(deliveryCourierPath, where, options);
export const createDeliveryCourier = (deliveryCourier: DeliveryCourier, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(deliveryCourierPath, undefined, deliveryCourier, { audit });
};
export const updateDeliveryCourier = (
  id: string,
  data: Partial<DeliveryCourierDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch, audit } = options ?? {};
  return firebaseManager.updateDoc(deliveryCourierPath, id, data, { bBatch, audit });
};

// deliveryRouteHistory
const deliveryRouteHistoryPath = 'deliveryRouteHistory';
export const observeDeliveryRouteHistoryDoc = (id: string) =>
  firebaseManager.observeDoc<DeliveryRouteHistoryDoc>(`${deliveryRouteHistoryPath}/${id}`);
export const observeDeliveryRouteHistory = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<DeliveryRouteHistoryDoc>(deliveryRouteHistoryPath, where, options);
export const getDeliveryRouteHistory = (id: string) =>
  firebaseManager.getDoc<DeliveryRouteHistoryDoc>(`${deliveryRouteHistoryPath}/${id}`);
export const createDeliveryRouteHistory = (
  id: string,
  data: DeliveryRouteHistory,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(deliveryRouteHistoryPath, id, data, {
    bBatch,
    audit,
  });
};
export const updateDeliveryRouteHistory = (
  id: string,
  data: Partial<DeliveryRouteHistoryDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(deliveryRouteHistoryPath, id, data, {
    bBatch,
    audit,
  });
};
export const setDeliveryRouteHistory = (
  id: string,
  data: DeliveryRouteHistory,
  options?: { bMerge?: boolean; bBatch?: boolean; audit?: AuditOptions },
) => firebaseManager.setDoc(deliveryRouteHistoryPath, id, data, options);
export const softDeleteDeliveryRouteHistory = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    deliveryRouteHistoryPath,
    id,
    { isDeleted: true, _timeDelete: Timestamp.now() },
    { bBatch, audit },
  );
};

// config/businessInfo
const configBusinessInfoPath = 'config/businessInfo';
export const getConfigBusinessInfo = () => firebaseManager.getDoc<BusinessInfoDoc>(configBusinessInfoPath);

// deliveryPerformance
const deliveryPerformancePath = 'deliveryPerformance';
export const observeDeliveryPerformance = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<DeliveryPerformanceDoc>(deliveryPerformancePath, where, options);

// promotionSection
const promotionSectionPath = 'promotionSection';
export const getPromotionSection = (id: string) =>
  firebaseManager.getDoc<PromotionSectionDoc>(`${promotionSectionPath}/${id}`);
export const observePromotionSection = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PromotionSectionDoc>(promotionSectionPath, where, options);
export const createPromotionSection = (data: PromotionSection, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(promotionSectionPath, undefined, data, { audit });
};
export const updatePromotionSection = (
  id: string,
  data: Partial<PromotionSectionDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(promotionSectionPath, id, data, {
    bBatch,
    audit,
  });
};

// customPromotionSection
const customPromotionSectionPath = 'customPromotionSection';
export const getCustomPromotionSection = (id: string) =>
  firebaseManager.getDoc<CustomPromotionSectionDoc>(`${customPromotionSectionPath}/${id}`);
export const observeCustomPromotionSection = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<CustomPromotionSectionDoc>(customPromotionSectionPath, where, options);
export const createCustomPromotionSection = (data: CustomPromotionSection, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(customPromotionSectionPath, undefined, data, { audit });
};
export const updateCustomPromotionSection = (
  id: string,
  data: Partial<CustomPromotionSectionDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(customPromotionSectionPath, id, data, {
    bBatch,
    audit,
  });
};

// productSnapshot
const productSnapshotPath = 'productSnapshot';
export const getProductSnapshots = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductSnapshotDoc>(productSnapshotPath, where, options);
export const getProductSnapshot = (id: string) =>
  firebaseManager.getDoc<ProductSnapshotDoc>(`${productSnapshotPath}/${id}`);

// paymentItem
const paymentItemPath = 'paymentItem';
export const observePaymentItem = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PaymentItemDoc>(paymentItemPath, where, options);
export const createPaymentItem = (data: PaymentItem, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(paymentItemPath, undefined, data, {
    bBatch,
    audit,
  });
};
export const updatePaymentItem = (
  id: string,
  data: Partial<PaymentItem>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(paymentItemPath, id, data, {
    bBatch,
    audit,
  });
};
export const deletePaymentItem = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    paymentItemPath,
    id,
    {
      deletedAt: formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900"),
    },
    {
      bBatch,
      audit,
    },
  );
};

// hyosungCMSMember
const hyosungCMSMemberPath = 'hyosungCMSMember';
export const getHyosungCMSMembers = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<HyosungCMSMemberDoc>(hyosungCMSMemberPath, where, options);
export const setHyosungCMSMember = (
  id: string,
  data: HyosungCMSMember,
  options: {
    bMerge: boolean;
    bBatch: boolean;
    audit?: AuditOptions;
  },
) => firebaseManager.setDoc(hyosungCMSMemberPath, id, data, options);
export const observeHyosungCMSMember = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<HyosungCMSMemberDoc>(hyosungCMSMemberPath, where, options);

// dailyIssue
const dailyIssuePath = 'dailyIssue';
export const createDailyIssue = (id: string, data: DailyIssue, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(dailyIssuePath, id, data, { audit });
};
export const getDailyIssue = (id: string) => firebaseManager.getDoc<DailyIssueDoc>(`${dailyIssuePath}/${id}`);
export const updateDailyIssue = (
  id: string,
  data: Partial<
    DailyIssue & {
      history: any;
    }
  >,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(dailyIssuePath, id, data, { audit });
};
export const observeDailyIssueDoc = (docId: string) =>
  firebaseManager.observeDoc<DailyIssueDoc>(`${dailyIssuePath}/${docId}`);

// invoice
const invoicePath = 'invoice';
export const getInvoice = (id: string) => firebaseManager.getDoc<InvoiceDoc>(`${invoicePath}/${id}`);
export const createInvoice = (data: Invoice, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(invoicePath, undefined, data, { bBatch, audit });
};
export const updateInvoice = (
  id: string,
  data: Partial<InvoiceDoc>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(invoicePath, id, data, { bBatch, audit });
};
export const observeInvoices = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<InvoiceDoc>(invoicePath, where, options);

// settlementResult
const settlementResultPath = 'settlementResult';
export const getSettlementResult = (id: string) =>
  firebaseManager.getDoc<SettlementResultDoc>(`${settlementResultPath}/${id}`);
export const observeSettlementResult = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<SettlementResultDoc>(settlementResultPath, where, options);
export const createSettlementResult = (
  data: SettlementResult,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(settlementResultPath, undefined, data, { bBatch, audit });
};
export const updateSettlementResult = (
  id: string,
  data: Partial<SettlementResult>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(settlementResultPath, id, data, { bBatch, audit });
};

// invoiceDetail
const invoiceDetailPath = 'invoiceDetail';
export const observeInvoiceDetail = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<InvoiceDetailDoc>(invoiceDetailPath, where, options);
export const deleteInvoiceDetail = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    invoiceDetailPath,
    id,
    {
      deletedAt: formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900"),
    },
    {
      bBatch,
      audit,
    },
  );
};

// memo
const memoPath = 'memo';
export const getMemo = (id: string) => firebaseManager.getDoc<MemoDoc>(`${memoPath}/${id}`);
export const observeMemoDoc = (id: string) => firebaseManager.observeDoc<MemoDoc>(`${memoPath}/${id}`);
export const updateMemo = (id: string, data: Partial<MemoDoc>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(memoPath, id, data, { audit });
};

// garakMarketProductPriceTrend
const garakMarketProductPriceTrendPath = 'garakMarketProductPriceTrend';
export const observeGarakMarketProductPriceTrend = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<GarakMarketProductPriceTrendDoc>(garakMarketProductPriceTrendPath, where, options);
export const createGarakMarketProductPriceTrend = (
  id: string,
  data: GarakMarketProductPriceTrend,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(garakMarketProductPriceTrendPath, id, data, { audit });
};
export const deleteGarakMarketProductPriceTrend = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${garakMarketProductPriceTrendPath}/${id}`, { audit });
};

// guProductPriceTrend
const guProductPriceTrendPath = 'guProductPriceTrend';
export const observeGuProductPriceTrend = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<GuProductPriceTrendDoc>(guProductPriceTrendPath, where, options);

// competitorProductMapping
const competitorProductMappingPath = 'competitorProductMapping';
export const observeCompetitorProductMapping = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<CompetitorProductMappingDoc>(competitorProductMappingPath, where, options);
export const createCompetitorProductMapping = (data: CompetitorProductMapping, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(competitorProductMappingPath, undefined, data, { audit });
};
export const deleteCompetitorProductMapping = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${competitorProductMappingPath}/${id}`, { audit });
};

// dabomFoodProduct
const dabomFoodProductPath = 'dabomFoodProduct';
export const getDabomFoodProduct = (id: string) =>
  firebaseManager.getDoc<DabomFoodProduct>(`${dabomFoodProductPath}/${id}`);

// CJFreshwayProduct
const CJFreshwayProductPath = 'CJFreshwayProduct';
export const getCJFreshwayProduct = (id: string) =>
  firebaseManager.getDoc<CJFreshwayProduct>(`${CJFreshwayProductPath}/${id}`);

// sehyeonFnBProduct
const sehyeonFnBProductPath = 'sehyeonFnBProduct';
export const getSehyeonFnBProduct = (id: string) =>
  firebaseManager.getDoc<SehyeonFnBProduct>(`${sehyeonFnBProductPath}/${id}`);

// foodpangProduct
const foodpangProductPath = 'foodpangProduct';
export const getFoodpangProduct = (id: string) =>
  firebaseManager.getDoc<FoodpangProductDoc>(`${foodpangProductPath}/${id}`);

// productWeeklyPrice
const productWeeklyPricePath = 'productWeeklyPrice';
export const getProductWeeklyPrice = (id: string) =>
  firebaseManager.getDoc<ProductWeeklyPriceDoc>(`${productWeeklyPricePath}/${id}`);
export const observeProductWeeklyPrice = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductWeeklyPriceDoc>(productWeeklyPricePath, where, options);

// partnersUser
const partnersUserPath = 'partnersUser';
export const getPartnersUser = (id: string) => firebaseManager.getDoc<PartnersUserDoc>(`${partnersUserPath}/${id}`);
export const observePartnersUserDoc = (id: string) =>
  firebaseManager.observeDoc<PartnersUserDoc>(`${partnersUserPath}/${id}`);
export const getPartnersUsers = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<PartnersUserDoc>(partnersUserPath, where, options);
export const observePartnersUsers = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PartnersUserDoc>(partnersUserPath, where, options);
export const updatePartnersUser = (
  id: string,
  data: Record<string, any>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(partnersUserPath, id, data, {
    bBatch,
    audit,
  });
};
export const updatePartnersUserColor = (
  id: string,
  color: string,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    partnersUserPath,
    id,
    { ['deliveryPartnerStatus.color']: color },
    {
      bBatch,
      audit,
    },
  );
};
export const deletePartnersUser = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    partnersUserPath,
    id,
    {
      deletedAt: formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900"),
      ['deliveryPartnerStatus.isActive']: false,
      ['deliveryPartnerStatus.vehicleId']: null,
    },
    { audit },
  );
};

// pickupTask
const pickupTaskPath = 'pickupTask';
export const getPickupTask = (id: string) => firebaseManager.getDoc<PickupTaskDoc>(`${pickupTaskPath}/${id}`);
export const getPickupTaskForOrder = (order: OrderDoc) => {
  const pickupTaskId = `${order.pickupPartnerId}-order-${order._id}`;
  return firebaseManager.getDoc<PickupTaskDoc>(`${pickupTaskPath}/${pickupTaskId}`);
};
export const observePickupTaskDoc = (id: string) =>
  firebaseManager.observeDoc<PickupTaskDoc>(`${pickupTaskPath}/${id}`);
export const getPickupTasks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<PickupTaskDoc>(pickupTaskPath, where, options);
export const observePickupTask = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PickupTaskDoc>(pickupTaskPath, where, options);
export const observePickupTaskWithOr = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollectionWithOr<PickupTaskDoc>(pickupTaskPath, where, options);
export const deletePickupTask = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.deleteDocument(`${pickupTaskPath}/${id}`, {
    bBatch,
    audit,
  });
};
export const setPickupTask = (
  data: PickupTask,
  options?: { bMerge?: boolean; bBatch?: boolean; audit?: AuditOptions },
) => firebaseManager.setDoc(pickupTaskPath, data._id, data, options);
export const updatePickupTask = (
  id: string,
  data: Partial<PickupTask>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(pickupTaskPath, id, data, {
    bBatch,
    audit,
  });
};

// deliveryTask
const deliveryTaskPath = 'deliveryTask';
export const getDeliveryTask = (id: string) => firebaseManager.getDoc<DeliveryTaskDoc>(`${deliveryTaskPath}/${id}`);
export const getDeliveryTaskForOrder = (order: OrderDoc) => {
  const deliveryTaskId = `${order.deliveryPartnerId}-order-${order._id}`;
  return firebaseManager.getDoc<DeliveryTaskDoc>(`${deliveryTaskPath}/${deliveryTaskId}`);
};
export const observeDeliveryTaskDoc = (id: string) =>
  firebaseManager.observeDoc<DeliveryTaskDoc>(`${deliveryTaskPath}/${id}`);
export const getDeliveryTasks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<DeliveryTaskDoc>(deliveryTaskPath, where, options);
export const observeDeliveryTask = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<DeliveryTaskDoc>(deliveryTaskPath, where, options);
export const observeDeliveryTaskWithOr = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollectionWithOr<DeliveryTaskDoc>(deliveryTaskPath, where, options);
export const deleteDeliveryTask = (id: string, options?: { bBatch?: boolean; audit?: AuditOptions }) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.deleteDocument(`${deliveryTaskPath}/${id}`, {
    bBatch,
    audit,
  });
};
export const setDeliveryTask = (
  data: DeliveryTask,
  options?: { bMerge?: boolean; bBatch?: boolean; audit?: AuditOptions },
) => firebaseManager.setDoc(deliveryTaskPath, data._id, data, options);
export const updateDeliveryTask = (
  id: string,
  data: Partial<DeliveryTask>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(deliveryTaskPath, id, data, {
    bBatch,
    audit,
  });
};

// partnersVehicle
const partnersVehiclePath = 'partnersVehicle';
export const observePartnersVehicle = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PartnersVehicleDoc>(partnersVehiclePath, where, options);
export const createPartnersVehicle = (data: PartnersVehicle, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(partnersVehiclePath, undefined, data, { audit });
};
export const deletePartnersVehicle = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${partnersVehiclePath}/${id}`, { audit });
};

// partnersDevice
const partnersDevicePath = 'partnersDevice';
export const observePartnersDevices = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PartnersDeviceDoc>(partnersDevicePath, where, options);
export const getPartnersDevices = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<PartnersDeviceDoc>(partnersDevicePath, where, options);

// consoleDevice (운영팀 콘솔 PWA Web Push 토큰 컬렉션)
export const getConsoleDevice = (id: string) => firebaseManager.getDoc<ConsoleDeviceDoc>(`${consoleDevicePath}/${id}`);
export const setConsoleDevice = (id: string, data: ConsoleDevice, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(consoleDevicePath, id, data, { bMerge: true, audit });
};
export const updateConsoleDevice = (id: string, data: Partial<ConsoleDevice>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(consoleDevicePath, id, data, { audit });
};

// logOrder
const logOrderPath = 'logOrder';
export const getLogOrdersByOrderId = (orderId: string) =>
  firebaseManager.getDocsArrayWithWhere<LogDoc<LogOrder>>(logOrderPath, [['body.orderId', '==', orderId]]);

// productInventory
const productInventoryPath = 'productInventory';
export const getProductInventoryId = () => firebaseManager.docRefId(productInventoryPath);
export const getProductInventory = (id: string) =>
  firebaseManager.getDoc<ProductInventoryDoc>(`${productInventoryPath}/${id}`);
export const getProductInventories = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductInventoryDoc>(productInventoryPath, where, options);
export const createProductInventory = (
  id: string | undefined,
  data: ProductInventory,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => firebaseManager.createDoc(productInventoryPath, id, data, options);
export const observeProductInventories = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductInventoryDoc>(productInventoryPath, where, options);
export const updateProductInventory = (
  id: string,
  data: Partial<ProductInventory>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(productInventoryPath, id, data, {
    bBatch,
    audit,
  });
};
export const updateProductInventoryForField = (
  id: string,
  field: string,
  value: any,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(
    productInventoryPath,
    id,
    {
      [field]: value,
    },
    {
      bBatch,
      audit,
    },
  );
};
/** '일일 출고 현황'의 매입가 변경에서 사용한다. */
export const updateProductInventoryForFieldBatch = (
  id: string,
  data: Record<string, any>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(productInventoryPath, id, data, {
    bBatch: true,
    audit,
  });
};
export const updateInventoryUnitBarcode = (
  inventoryId: string,
  unit: ProductInventoryUnit,
  barcode: string | null,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    productInventoryPath,
    inventoryId,
    {
      [`uom.${unit}.barcode`]: barcode,
    },
    { audit },
  );
};
export const updateInventoryUnitCost = (
  inventoryId: string,
  unit: ProductInventoryUnit,
  cost: number | null,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    productInventoryPath,
    inventoryId,
    {
      [`uom.${unit}.cost`]: cost,
    },
    { audit },
  );
};
export const updateProductInventorySupplierId = async (
  id: string,
  supplierId: string,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  const inventory = await getProductInventory(id);
  if (!inventory) {
    throw new Error('Inventory not found');
  }
  return firebaseManager.updateDoc(
    productInventoryPath,
    id,
    {
      ['purchaseConfig.supplierId']: supplierId,
      ['purchaseConfig.purchaseProductName']: inventory.inventoryName,
    },
    {
      bBatch,
      audit,
    },
  );
};

export const deleteProductInventory = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    productInventoryPath,
    id,
    {
      deletedAt: formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900"),
    },
    { audit },
  );
};

// productInventoryHistory
const productInventoryHistoryPath = 'productInventoryHistory';
export const getProductInventoryHistory = (id: string) =>
  firebaseManager.getDoc<ProductInventoryHistoryDoc>(`${productInventoryHistoryPath}/${id}`);
export const getProductInventoryHistories = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductInventoryHistoryDoc>(productInventoryHistoryPath, where, options);
export const observeProductInventoryHistory = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductInventoryHistoryDoc>(productInventoryHistoryPath, where, options);

// productSupplier
const productSupplierPath = 'productSupplier';
export const createProductSupplier = (data: ProductSupplier, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(productSupplierPath, undefined, data, { audit });
};
export const getProductSupplier = (id: string) =>
  firebaseManager.getDoc<ProductSupplierDoc>(`${productSupplierPath}/${id}`);
export const getProductSuppliers = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductSupplierDoc>(productSupplierPath, where, options);
export const observeProductSupplier = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductSupplierDoc>(productSupplierPath, where, options);

// productBatchUpdateHistory
const productBatchUpdateHistoryPath = 'productBatchUpdateHistory';
export const createProductBatchUpdateHistory = (
  data: ProductBatchUpdateHistory,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(productBatchUpdateHistoryPath, undefined, data, { audit });
};
export const updateProductBatchUpdateHistory = (
  id: string,
  data: Partial<ProductBatchUpdateHistory>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(productBatchUpdateHistoryPath, id, data, { audit });
};
export const getProductBatchUpdateHistories = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductBatchUpdateHistoryDoc>(productBatchUpdateHistoryPath, where, options);
export const observeProductBatchUpdateHistory = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductBatchUpdateHistoryDoc>(productBatchUpdateHistoryPath, where, options);

// productInboundTransaction
const productInboundTransactionPath = 'productInboundTransaction';
export const getProductInboundTransactionId = () => firebaseManager.docRefId(productInboundTransactionPath);
export const getProductInboundTransaction = (id: string) =>
  firebaseManager.getDoc<ProductInboundTransactionDoc>(`${productInboundTransactionPath}/${id}`);
export const getProductInboundTransactions = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductInboundTransactionDoc>(productInboundTransactionPath, where, options);
export const observeProductInboundTransaction = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductInboundTransactionDoc>(productInboundTransactionPath, where, options);

// productOutboundTransaction
const productOutboundTransactionPath = 'productOutboundTransaction';
export const getProductOutboundTransactionId = () => firebaseManager.docRefId(productOutboundTransactionPath);
export const getProductOutboundTransaction = (id: string) =>
  firebaseManager.getDoc<ProductOutboundTransactionDoc>(`${productOutboundTransactionPath}/${id}`);
export const getProductOutboundTransactions = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductOutboundTransactionDoc>(productOutboundTransactionPath, where, options);
export const observeProductOutboundTransaction = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductOutboundTransactionDoc>(productOutboundTransactionPath, where, options);

// inventoryIssue
const inventoryIssuePath = 'inventoryIssue';
export const getInventoryIssueId = () => firebaseManager.docRefId(inventoryIssuePath);
export const getInventoryIssue = (id: string) =>
  firebaseManager.getDoc<InventoryIssueDoc>(`${inventoryIssuePath}/${id}`);
export const getInventoryIssueArrayWithWhere = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<InventoryIssueDoc>(inventoryIssuePath, where, options);
export const observeInventoryIssue = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<InventoryIssueDoc>(inventoryIssuePath, where, options);
export const createInventoryIssue = (data: InventoryIssue, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(inventoryIssuePath, undefined, data, { audit });
};
export const updateInventoryIssue = (id: string, data: Partial<InventoryIssue>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(inventoryIssuePath, id, data, { audit });
};

// productSupplierInventoryReceipt
const productSupplierInventoryReceiptPath = 'productSupplierInventoryReceipt';
export const getProductSupplierInventoryReceiptId = () => firebaseManager.docRefId(productSupplierInventoryReceiptPath);
export const getProductSupplierInventoryReceipt = (id: string) =>
  firebaseManager.getDoc<ProductSupplierInventoryReceiptDoc>(`${productSupplierInventoryReceiptPath}/${id}`);
export const updateProductSupplierInventoryReceipt = (
  id: string,
  data: Partial<ProductSupplierInventoryReceipt>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(productSupplierInventoryReceiptPath, id, data, { audit });
};
export const getProductSupplierInventoryReceipts = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductSupplierInventoryReceiptDoc>(
    productSupplierInventoryReceiptPath,
    where,
    options,
  );
export const observeProductSupplierInventoryReceipt = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductSupplierInventoryReceiptDoc>(
    productSupplierInventoryReceiptPath,
    where,
    options,
  );

// productSupplierPurchaseOrder
const productSupplierPurchaseOrderPath = 'productSupplierPurchaseOrder';
export const getProductSupplierPurchaseOrder = (id: string) =>
  firebaseManager.getDoc<ProductSupplierPurchaseOrderDoc>(`${productSupplierPurchaseOrderPath}/${id}`);
export const getProductSupplierPurchaseOrders = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ProductSupplierPurchaseOrderDoc>(
    productSupplierPurchaseOrderPath,
    where,
    options,
  );
export const observeProductSupplierPurchaseOrder = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ProductSupplierPurchaseOrderDoc>(productSupplierPurchaseOrderPath, where, options);
export const addMobileMessageSendRequestForPurchaseOrder = (
  id: string,
  requestId: string,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  const messageSendRequest: PurchaseOrderMessageSendRequest = {
    requestCollection: PurchaseOrderMessageSendRequestCollection.MOBILE_MESSAGE,
    requestId,
    requestedAt: formatDate(Timestamp.now().toDate(), "yyyy-MM-dd'T'HH:mm:ss+0900"),
  };
  return firebaseManager.updateDoc(
    productSupplierPurchaseOrderPath,
    id,
    {
      messageSendRequests: arrayUnion(messageSendRequest),
    },
    { audit },
  );
};
export const updateProductSupplierPurchaseOrderMessageBody = (
  id: string,
  oldValue: string,
  newValue: string,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  const timestamp = formatDate(Timestamp.now().toDate(), "yyyy-MM-dd'T'HH:mm:ss+0900");
  return firebaseManager.updateDoc(
    productSupplierPurchaseOrderPath,
    id,
    {
      messageBody: newValue,
      messageBodyEditedAt: timestamp,
      transactionHistory: arrayUnion({
        modifiedAt: timestamp,
        snapshot: oldValue,
      }),
    },
    { audit },
  );
};

// dailyInventoryChanges
const dailyInventoryChangesPath = 'dailyInventoryChanges';
export const observeDailyInventoryChanges = (id: string) =>
  firebaseManager.observeDoc<DailyInventoryChangesDoc>(`${dailyInventoryChangesPath}/${id}`);
export const setDailyInventoryChanges = (
  id: string,
  data: Partial<DailyInventoryChanges>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(dailyInventoryChangesPath, id, data, {
    bMerge: true,
    audit,
  });
};

// orderProductAlertConf
const orderProductAlertConfPath = 'orderProductAlertConf';
export const observeOrderProductAlertConf = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<OrderProductAlertConfDoc>(orderProductAlertConfPath, where, options);
export const createOrderProductAlertConf = (data: OrderProductAlertConf, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(orderProductAlertConfPath, undefined, data, { audit });
};
export const updateOrderProductAlertConf = (
  id: string,
  data: Partial<OrderProductAlertConf>,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(orderProductAlertConfPath, id, data, { audit });
};
export const addProductToOrderProductAlertConf = (
  id: string,
  productId: string,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    orderProductAlertConfPath,
    id,
    {
      productIds: arrayUnion(productId),
    },
    { audit },
  );
};
export const removeProductFromOrderProductAlertConf = (
  id: string,
  productId: string,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    orderProductAlertConfPath,
    id,
    {
      productIds: arrayRemove(productId),
    },
    { audit },
  );
};
export const getOrderProductAlertConf = (id: string) =>
  firebaseManager.getDoc<OrderProductAlertConfDoc>(`${orderProductAlertConfPath}/${id}`);
export const deleteOrderProductAlertConf = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${orderProductAlertConfPath}/${id}`, { audit });
};

// issueCase
const issueCasePath = 'issueCase';
export const getIssueCase = (id: string) => firebaseManager.getDoc<IssueCaseDoc>(`${issueCasePath}/${id}`);
export const getIssueCases = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<IssueCaseDoc>(issueCasePath, where, options);
export const observeIssueCaseDoc = (id: string) => firebaseManager.observeDoc<IssueCaseDoc>(`${issueCasePath}/${id}`);
export const observeIssueCases = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<IssueCaseDoc>(issueCasePath, where, options);
export const createIssueCase = (data: IssueCase, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(issueCasePath, undefined, data, { audit });
};
export const updateIssueCase = (
  id: string,
  data: Partial<IssueCase>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(issueCasePath, id, data, { bBatch, audit: withNewStatus(data, audit) });
};
export const addProductToIssueCase = (
  id: string,
  issueProduct: IssueProduct,
  amount: IssueAmountStructure,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueCasePath,
    id,
    {
      products: arrayUnion(issueProduct),
      amount,
    },
    { audit },
  );
};
export const removeProductFromIssueCase = (
  id: string,
  issueProduct: IssueProduct,
  amount: IssueAmountStructure | null,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueCasePath,
    id,
    {
      products: arrayRemove(issueProduct),
      amount,
    },
    { audit },
  );
};
export const deleteIssueCase = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  const data = {
    status: IssueCaseStatusCode.DELETED,
    _timeDelete: Timestamp.now(),
  };
  return firebaseManager.updateDoc(issueCasePath, id, data, { audit: withNewStatus(data, audit) });
};
export const addImageToIssueCase = (
  id: string,
  imageFileId: string,
  issueImage: IssueImage,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueCasePath,
    id,
    {
      [`images.${imageFileId}`]: issueImage,
    },
    { audit },
  );
};
export const removeImageFromIssueCase = (id: string, imageFileId: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueCasePath,
    id,
    {
      [`images.${imageFileId}`]: deleteField(),
    },
    { audit },
  );
};

// issueCaseMessageLink
const issueCaseMessageLinkPath = 'issueCaseMessageLink';
export const getIssueCaseMessageLink = (id: string) =>
  firebaseManager.getDoc<IssueCaseMessageLinkDoc>(`${issueCaseMessageLinkPath}/${id}`);
export const getIssueCaseMessageLinks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<IssueCaseMessageLinkDoc>(issueCaseMessageLinkPath, where, options);
export const observeIssueCaseMessageLinks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<IssueCaseMessageLinkDoc>(issueCaseMessageLinkPath, where, options);
export const setIssueCaseMessageLink = (id: string, data: IssueCaseMessageLink, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(issueCaseMessageLinkPath, id, data, { bMerge: false, audit });
};
export const deleteIssueCaseMessageLink = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${issueCaseMessageLinkPath}/${id}`, { audit });
};

// issueTask
const issueTaskPath = 'issueTask';
export const getIssueTask = (id: string) => firebaseManager.getDoc<IssueTaskDoc>(`${issueTaskPath}/${id}`);
export const getIssueTasks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<IssueTaskDoc>(issueTaskPath, where, options);
export const observeIssueTasks = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<IssueTaskDoc>(issueTaskPath, where, options);
export const createIssueTask = (data: IssueTask, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(issueTaskPath, undefined, data, { audit });
};
export const updateIssueTask = (
  id: string,
  data: Partial<IssueTask>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(issueTaskPath, id, data, { bBatch, audit: withNewStatus(data, audit) });
};
export const deleteIssueTask = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  const data = {
    status: IssueTaskStatus.DELETED,
    _timeDelete: Timestamp.now(),
  };
  return firebaseManager.updateDoc(issueTaskPath, id, data, { audit: withNewStatus(data, audit) });
};
export const addImageToIssueTaskDeliveryInfo = (
  id: string,
  imageFileId: string,
  issueImage: IssueImage,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueTaskPath,
    id,
    {
      [`deliveryInfo.images.${imageFileId}`]: issueImage,
    },
    { audit },
  );
};
export const removeImageFromIssueTaskDeliveryInfo = (
  id: string,
  imageFileId: string,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(
    issueTaskPath,
    id,
    {
      [`deliveryInfo.images.${imageFileId}`]: deleteField(),
    },
    { audit },
  );
};
/**
 * IssueTask의 일반 필드와 nested field를 동시에 업데이트
 * @example
 * // 일반 필드와 nested 필드를 함께 업데이트
 * updateIssueTaskNestedFields(id, {
 *   status: IssueTaskStatus.COMPLETED,
 *   finishedAt: '2025-10-28T14:30:00+0900',
 *   deliveryInfo: { deliveryTaskFinishedAt: '2025-10-28T14:30:00+0900' }
 * });
 */
export const updateIssueTaskNestedFields = (
  id: string,
  data: Partial<Omit<IssueTask, 'pickupInfo' | 'deliveryInfo' | 'externalService' | 'invoiceInfo' | 'deadline'>> & {
    pickupInfo?: Partial<IssueTask['pickupInfo']>;
    deliveryInfo?: DeepPartial<IssueTask['deliveryInfo']>;
    externalService?: Partial<IssueTask['externalService']>;
    invoiceInfo?: Partial<IssueTask['invoiceInfo']>;
    deadline?: Partial<IssueTask['deadline']>;
  },
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  const nestedFields = ['pickupInfo', 'deliveryInfo', 'externalService', 'invoiceInfo', 'deadline'];
  const updateData: Record<string, any> = {};

  Object.entries(data).forEach(([key, value]) => {
    if (nestedFields.includes(key) && value && typeof value === 'object') {
      // nested 필드는 dot notation으로 변환
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        updateData[`${key}.${nestedKey}`] = nestedValue;
      });
    } else {
      // 일반 필드는 그대로 추가
      updateData[key] = value;
    }
  });

  return firebaseManager.updateDoc(issueTaskPath, id, updateData, { bBatch, audit: withNewStatus(updateData, audit) });
};

/**
 * 업데이트 데이터에 `status`가 포함된 경우, audit metadata에 새 status 값을 주입한다.
 * 이전 status는 추적하지 않으며 별도 read를 발생시키지 않는다.
 */
function withNewStatus(data: Record<string, unknown>, audit: AuditOptions | undefined): AuditOptions | undefined {
  if (data.status === undefined) return audit;
  if (audit === false) return audit;
  if (typeof audit === 'object' && audit?.suppress) return audit;

  const baseAudit = typeof audit === 'object' && audit !== null ? audit : {};
  return {
    ...baseAudit,
    metadata: { ...(baseAudit.metadata ?? {}), status: data.status },
  };
}

// issueLiability
const issueLiabilityPath = 'issueLiability';
export const getIssueLiabilityByCaseId = () => firebaseManager.docRefId(issueLiabilityPath);
export const getIssueLiability = (id: string) =>
  firebaseManager.getDoc<IssueLiabilityDoc>(`${issueLiabilityPath}/${id}`);
export const getIssueLiabilities = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<IssueLiabilityDoc>(issueLiabilityPath, where, options);
export const observeIssueLiabilities = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<IssueLiabilityDoc>(issueLiabilityPath, where, options);
export const observeIssueLiabilityDoc = (id: string) =>
  firebaseManager.observeDoc<IssueLiabilityDoc>(`${issueLiabilityPath}/${id}`);
export const setIssueLiability = (id: string | undefined, data: IssueLiability, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.setDoc(issueLiabilityPath, id, data, {
    bMerge: true,
    audit,
  });
};
export const updateIssueLiability = (id: string, data: Partial<IssueLiability>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(issueLiabilityPath, id, data, { audit });
};
export const deleteIssueLiability = (id: string, options?: { audit?: AuditOptions }) =>
  updateIssueLiability(id, { deletedAt: formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss+0900") }, options);

// storeSalesInfo
const storeSalesInfoPath = 'storeSalesInfo';
export const observeStoreSalesInfos = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<StoreSalesInfoDoc>(storeSalesInfoPath, where, options);
export const getStoreSalesInfo = (storeId: string) =>
  firebaseManager.getDoc<StoreSalesInfoDoc>(`${storeSalesInfoPath}/${storeId}`);
export const updateStoreSalesInfo = (id: string, data: Partial<StoreSalesInfo>, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.updateDoc(storeSalesInfoPath, id, data, { audit });
};

// imageFileOriginal
const imageFileOriginalPath = 'imageFileOriginal';
export const getImageFileOriginalId = () => firebaseManager.docRefId(imageFileOriginalPath);
export const getImageFileOriginal = (id: string) =>
  firebaseManager.getDoc<ImageFileOriginalDoc>(`${imageFileOriginalPath}/${id}`);
export const getImageFileOriginals = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ImageFileOriginalDoc>(imageFileOriginalPath, where, options);
export const createImageFileOriginal = (
  id: string,
  data: ImageFile,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(imageFileOriginalPath, id, data, { bBatch, audit });
};
export const deleteImageFileOriginal = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${imageFileOriginalPath}/${id}`, { audit });
};

// imageFileThumbnail
const imageFileThumbnailPath = 'imageFileThumbnail';
export const getImageFileThumbnail = (id: string) =>
  firebaseManager.getDoc<ImageFileThumbnailDoc>(`${imageFileThumbnailPath}/${id}`);
export const getImageFileThumbnails = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ImageFileThumbnailDoc>(imageFileThumbnailPath, where, options);
export const createImageFileThumbnail = (
  id: string,
  data: ImageFile,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.createDoc(imageFileThumbnailPath, id, data, { bBatch, audit });
};
export const deleteImageFileThumbnail = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${imageFileThumbnailPath}/${id}`, { audit });
};

// purchaseOrderSectionConfig
const purchaseOrderSectionConfigPath = 'purchaseOrderSectionConfig';
export const getPurchaseOrderSectionConfig = (id: string) =>
  firebaseManager.getDoc<PurchaseOrderSectionConfigDoc>(`${purchaseOrderSectionConfigPath}/${id}`);
export const getPurchaseOrderSectionConfigs = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<PurchaseOrderSectionConfigDoc>(purchaseOrderSectionConfigPath, where, options);
export const observePurchaseOrderSectionConfig = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<PurchaseOrderSectionConfigDoc>(purchaseOrderSectionConfigPath, where, options);
export const createPurchaseOrderSectionConfig = (
  data: PurchaseOrderSectionConfig,
  options?: { audit?: AuditOptions },
) => {
  const { audit } = options ?? {};
  return firebaseManager.createDoc(purchaseOrderSectionConfigPath, undefined, data, { audit });
};
export const updatePurchaseOrderSectionConfig = (
  id: string,
  data: Partial<PurchaseOrderSectionConfig>,
  options?: { bBatch?: boolean; audit?: AuditOptions },
) => {
  const { bBatch = false, audit } = options ?? {};
  return firebaseManager.updateDoc(purchaseOrderSectionConfigPath, id, data, { bBatch, audit });
};
export const deletePurchaseOrderSectionConfig = (id: string, options?: { audit?: AuditOptions }) => {
  const { audit } = options ?? {};
  return firebaseManager.deleteDocument(`${purchaseOrderSectionConfigPath}/${id}`, { audit });
};

// ==================== CommerceNotice ====================
const commerceNoticePath = 'commerceNotice';
export const getCommerceNotice = (id: string) =>
  firebaseManager.getDoc<CommerceNoticeDoc>(`${commerceNoticePath}/${id}`);
export const getCommerceNotices = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<CommerceNoticeDoc>(commerceNoticePath, where, options);
export const observeCommerceNotice = (id: string) =>
  firebaseManager.observeDoc<CommerceNoticeDoc>(`${commerceNoticePath}/${id}`);
export const observeCommerceNotices = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<CommerceNoticeDoc>(commerceNoticePath, where, options);
export const createCommerceNotice = (data: CommerceNotice, id?: string) =>
  firebaseManager.createDoc(commerceNoticePath, id, data);
export const updateCommerceNotice = (id: string, data: Partial<CommerceNotice>, bBatch = false) =>
  firebaseManager.updateDoc(commerceNoticePath, id, data, { bBatch });
export const deleteCommerceNotice = (id: string) =>
  firebaseManager.updateDoc(commerceNoticePath, id, {
    _timeDelete: Timestamp.now(),
  });

// ==================== Channel ====================
const channelCollectionPath = 'channel';
export const observeChannels = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ChannelDoc>(channelCollectionPath, where, options);
export const getChannel = (channelId: string) =>
  firebaseManager.getDoc<ChannelDoc>(`${channelCollectionPath}/${channelId}`);
export const getChannels = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ChannelDoc>(channelCollectionPath, where, options);
export const createChannel = (data: Channel, id?: string) => firebaseManager.createDoc(channelCollectionPath, id, data);
export const updateChannel = (channelId: string, data: Partial<Channel>) =>
  firebaseManager.updateDoc(channelCollectionPath, channelId, data);

// ==================== TriggerChannelMessage ====================
const triggerChannelMessagePath = 'triggerChannelMessage';
export const observeTriggerChannelMessages = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ChannelMessageDoc>(triggerChannelMessagePath, where, options);
export const getTriggerChannelMessages = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ChannelMessageDoc>(triggerChannelMessagePath, where, options);
export const createTriggerChannelMessage = (data: ChannelMessage, id?: string) =>
  firebaseManager.createDoc(triggerChannelMessagePath, id, data);

// ==================== NoTriggerChannelMessage ====================
const noTriggerChannelMessagePath = 'noTriggerChannelMessage';
export const observeNoTriggerChannelMessages = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<ChannelMessageDoc>(noTriggerChannelMessagePath, where, options);
export const getNoTriggerChannelMessages = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<ChannelMessageDoc>(noTriggerChannelMessagePath, where, options);
export const createNoTriggerChannelMessage = (data: ChannelMessage, id?: string) =>
  firebaseManager.createDoc(noTriggerChannelMessagePath, id, data);

// ==================== FCMRequest ====================
const fcmRequestCollectionPath = 'fcmRequest';
export const observeFcmRequests = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.observeCollection<FCMRequestDoc>(fcmRequestCollectionPath, where, options);
export const getFcmRequests = (where: WHERE[] = [], options?: QueryOptions) =>
  firebaseManager.getDocsArrayWithWhere<FCMRequestDoc>(fcmRequestCollectionPath, where, options);

export const setPackingInfoSnapshot = (date: string, data: PackingInfoSnapshot) =>
  // bMerge=false — 이전 공유의 rows/products 가 섞이지 않게 통째로 교체한다.
  firebaseManager.setDoc(packingInfoSnapshotPath, date, data, {
    bMerge: false,
    audit: { summary: `기타 인쇄물 파트너스 공유 ${date} (행 ${data.rows.length}건)` },
  });
